const state = () => ({
  DataFrom2: {
    tes_id: "",
    pre_id: "",
    stu_fname: "",
    stu_lname: "",
    stu_nicname: "",
    stu_fname_en: "",
    stu_lname_en: "",
    stu_old_school: "",
    edl_id: "",
    edu_id: "03",
    cla_id: "",
    dep_id: "",
    sdep_id: "",
    stu_old_All_sdep_id: "",
    stu_old_cla_id: "",
    stu_old_fac_id: "",
    stu_old_dep_id: "",
    stu_old_sdep_id: "",
    cap_id: "",
    fac_id: "",
    ver_id: "",
    planID: "",
    stu_new_All_sdep_id: "",
    sec_class: "",
    sec_room: "",
    sec_group: "",
    select_year: "",
    link_line_group: "",

    stu_old_school_name: "",
    provinceSearch: "เชียงใหม่",
  },
  status: true,
  DataPrename: [],
  Dataschoolinthailand: [],
  DataEducateLevel: [],
  DataEducate: [],
  DataClass: [],
  DataDepartmentStu: [],
  DataBorrowStu: [],
  DataSubDepartmentStu: [],
  DataSignupPayManual: [],
  DataAllSubDepartment: [],
  SetStep2: [],
  DataDepRegis: [],
  DatacheckVer: [],
  DataCheckBayAll: [],
  DataProvince: [],
  DataOldSchool: [],
});
/* ========== getters ========== */
const getters = {
  _getDataFrom2: (state) => {
    return state.DataFrom2;
  },
  _getDataprename: (state) => {
    return state.DataPrename;
  },
  _getDataschoolinthailand: (state) => {
    return state.Dataschoolinthailand;
  },
  _getDataEducateLevel: (state) => {
    return state.DataEducateLevel;
  },
  _getDataEducate: (state) => {
    return state.DataEducate;
  },
  _getDataClass: (state) => {
    return state.DataClass;
  },
  _getDataDepartmentStu: (state) => {
    return state.DataDepartmentStu;
  },
  _getDataAllSubDepartment: (state) => {
    return state.DataAllSubDepartment;
  },
  _getDataBorrowStu: (state) => {
    return state.DataBorrowStu;
  },
  _getDataSubDepartmentStu: (state) => {
    return state.DataSubDepartmentStu;
  },
  _getDataSignupPayManual: (state) => {
    return state.DataSignupPayManual;
  },
  _SetStep2: (state) => {
    return state.SetStep2;
  },
  _getDataDepRegis: (state) => {
    return state.DataDepRegis;
  },
  _getDatacheckVer: (state) => {
    return state.DatacheckVer;
  },
  _getDataProvince: (state) => {
    return state.DataProvince;
  },
  _getDataOldSchool: (state) => {
    return state.DataOldSchool;
  },
};
/* ========== actions ========== */
const actions = {
  async SetStepStatus({ state, rootState }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      const response = await window.Axios.post(
        `${window.api}exec/GetStepStatus2/`,
        state.DataFrom2
      );
      rootState.Main.DataStep2 = response.data;
    } catch (error) {
      console.error(error);
    }
  },
  async SetStep2({ state }) {
    // ======================== เบิกวันที่ปัจจุบันผ่าน APIs ========================
    try {
      let data = {
        tes_id: state.DataFrom2.tes_id,
      };
      const response = await window.Axios.post(
        `${window.api}post/GetStep2/`,
        data
      );
      state.SetStep2 = response.data;
      const statStep2 = state.SetStep2;
      const From2 = state.DataFrom2;

      if (state.SetStep2 != "") {
        statStep2.stu_old_school_name
          ? (From2.stu_old_school_name = statStep2.stu_old_school_name.trim())
          : "";
        statStep2.pre_id ? (From2.pre_id = statStep2.pre_id.trim()) : "";
        statStep2.stu_fname
          ? (From2.stu_fname = statStep2.stu_fname.trim())
          : "";
        statStep2.stu_lname
          ? (From2.stu_lname = statStep2.stu_lname.trim())
          : "";
        statStep2.stu_nicname
          ? (From2.stu_nicname = statStep2.stu_nicname.trim())
          : "";
        statStep2.stu_fname_en
          ? (From2.stu_fname_en = statStep2.stu_fname_en.trim())
          : "";
        statStep2.stu_lname_en
          ? (From2.stu_lname_en = statStep2.stu_lname_en.trim())
          : "";
        statStep2.stu_old_school
          ? (From2.stu_old_school = statStep2.stu_old_school.trim())
          : "";
        statStep2.cla_id ? (From2.cla_id = statStep2.cla_id.trim()) : "";
        statStep2.dep_id ? (From2.dep_id = statStep2.dep_id.trim()) : "";
        statStep2.stu_old_sdep_id
          ? (From2.stu_old_All_sdep_id = statStep2.stu_old_sdep_id.trim())
          : "";
        statStep2.ver_id ? (From2.ver_id = statStep2.ver_id.trim()) : "";
        statStep2.cap_id ? (From2.cap_id = statStep2.cap_id.trim()) : "";
        statStep2.fac_id ? (From2.fac_id = statStep2.fac_id.trim()) : "";
        statStep2.sdep_id ? (From2.sdep_id = statStep2.sdep_id.trim()) : "";
        statStep2.sec_class
          ? (From2.sec_class = statStep2.sec_class.trim())
          : "";
        statStep2.sec_group
          ? (From2.sec_group = statStep2.sec_group.trim())
          : "";
        statStep2.sec_room ? (From2.sec_room = statStep2.sec_room.trim()) : "";
        statStep2.stu_old_cla_id
          ? (From2.stu_old_cla_id = statStep2.stu_old_cla_id.trim())
          : "";
        statStep2.stu_old_fac_id
          ? (From2.stu_old_fac_id = statStep2.stu_old_fac_id.trim())
          : "";
        statStep2.stu_old_dep_id
          ? (From2.stu_old_dep_id = statStep2.stu_old_dep_id.trim())
          : "";
        statStep2.stu_old_sdep_id
          ? (From2.stu_old_sdep_id = statStep2.stu_old_sdep_id.trim())
          : "";
      }
      if (state.SetStep2.edl_id != "" && state.SetStep2.edu_id != "") {
        statStep2.edl_id ? (From2.edl_id = statStep2.edl_id.trim()) : "";
        From2.edu_id = statStep2.edu_id;
      } else if (statStep2.edl_id != "") {
        From2.edl_id = statStep2.edl_id;
      } else if (statStep2.edu_id != "") {
        From2.edu_id = statStep2.edu_id;
      }
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataPrename({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/Getprename/`);
      await commit("GET_DataPrename", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  // async GET_Dataschoolinthailand({ commit }) {
  //   try {
  //     const response = await window.Axios.get(
  //       `${window.api}get/Getschoolinthailand/`
  //     );
  //     await commit("GET_Dataschoolinthailand", response.data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // },
  async GET_DataEducateLevel({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetEducateLevel/`
      );
      await commit("GET_DataEducateLevel", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataEducate({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetEducate/`);
      await commit("GET_DataEducate", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataClass({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetClass/`);
      await commit("GET_DataClass", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataDepartmentStu({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetDepartmentStu/`
      );
      await commit("GET_DataDepartmentStu", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataSubDepartmentStu({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetSubDepartmentStu/`
      );
      await commit("GET_DataSubDepartmentStu", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataSignupPayManual({ commit }) {
    try {
      const response = await window.Axios.get(
        `${window.api}get/GetSignupPayManual/`
      );
      await commit("GET_DataSignupPayManual", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DataDepRegis({ state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetDepRegis/`,
        state.DataFrom2
      );
      state.DataDepRegis = response.data;
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataBorrowStu({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetBorrowStu/`,
        state.DataFrom2
      );
      await commit("GET_DataBorrowStu", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_DatacheckVer({ commit, state }) {
    try {
      const response = await window.Axios.post(
        `${window.api}post/GetcheckVer/`,
        state.DataFrom2
      );
      await commit("POST_DatacheckVer", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_Schoolinthailand({ commit, state }) {
    try {
      const data = { province: state.DataFrom2.provinceSearch };
      const response = await window.Axios.post(
        `${window.api}post/postSchoolinthailand/`,
        data
      );
      await commit("POST_Schoolinthailand", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_OldSchoolStudent({ commit, state }) {
    try {
      const data = { schoolId: state.DataFrom2.stu_old_school_name };
      const response = await window.Axios.post(
        `${window.api}post/postOldSchoolStudent/`,
        data
      );
      await commit("POST_OldSchoolStudent", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async POST_SignupDateOpen({ commit, state }) {
    try {
      const data = { select_year: state.DataFrom2.select_year };
      const response = await window.Axios.post(
        `${window.api}post/postSignupDateOpen/`,
        data
      );
      await commit("POST_SignupDateOpen", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataProvince({ commit }) {
    try {
      const response = await window.Axios.post(`${window.api}get/GetProvince/`);
      await commit("GET_DataProvince", response.data);
    } catch (error) {
      console.error(error);
    }
  },
  async GET_DataAllSubDepartment({ commit }) {
    try {
      const response = await window.Axios.get(`${window.api}get/GetAllSubDep/`);
      await commit("GET_DataAllSubDepartment", response.data);
    } catch (error) {
      console.error(error);
    }
  },
};

/* ========== mutations ========== */
const mutations = {
  GET_DataPrename(state, payload) {
    state.DataPrename = payload;
  },
  POST_Schoolinthailand(state, payload) {
    state.Dataschoolinthailand = payload;
  },
  POST_OldSchoolStudent(state, payload) {
    state.DataOldSchool = payload;
  },
  GET_DataEducateLevel(state, payload) {
    state.DataEducateLevel = payload;
  },
  GET_DataEducate(state, payload) {
    state.DataEducate = payload;
  },
  GET_DataClass(state, payload) {
    state.DataClass = payload;
  },
  GET_DataDepartmentStu(state, payload) {
    state.DataDepartmentStu = payload;
  },
  GET_DataAllSubDepartment(state, payload) {
    state.DataAllSubDepartment = payload;
  },
  GET_DataBorrowStu(state, payload) {
    state.DataBorrowStu = payload;
  },
  GET_DataSubDepartmentStu(state, payload) {
    state.DataSubDepartmentStu = payload;
  },
  GET_DataSignupPayManual(state, payload) {
    state.DataSignupPayManual = payload;
  },
  GET_DataProvince(state, payload) {
    state.DataProvince = payload;
  },
  POST_DatacheckVer(state, payload) {
    state.DatacheckVer = payload;
  },
  POST_SignupDateOpen(state, payload) {
    state.DataFrom2.link_line_group = payload;
  },
};

/* ========== Export ========== */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
